module.exports = __webpack_public_path__ + "static/media/boat-img-6.e0d7f4ba.jpg";